/**
 * Fuel policy type values for rentals
 */
export enum FuelPolicyTypeEnum {
	/** Receive full, return full. Charge if not. */
	FULL_TO_FULL = 'full_to_full',
	/** Return with same level as pickup. */
	SAME_TO_SAME = 'same_to_same',
	/** Prepay full tank, return any level. No refund. */
	FULL_TO_EMPTY = 'full_to_empty',
	/** Pay for fuel used at company rate. */
	PAY_AS_YOU_GO = 'pay_as_you_go',
}
